var styles = {"root":"Weekdays_root__BFsVa","day":"Weekdays_day__Vk6fu"};

export default styles;
